const getAllServiceRequestsQuery = () => {
    const query = `
    query MyQuery {
      getServiceRequests
    }    
      `;
    return query;
  };
  
  export { getAllServiceRequestsQuery };